import { Component, Inject, Optional } from '@angular/core';
import { LsImagePipe, XsI18nPipe } from '@nx-fe/pipes';
import { MessageTransportService } from '@nx-fe/services';
import { CellRendererBase, CellRendererData, CELL_RENDERER_TOKEN } from '../cell-renderer';
import { IconCellData, IconCellIcon } from '../renderer.models';

@Component({
  selector: 'ins-icon-cell-renderer',
  templateUrl: './icon-cell-renderer.component.html',
  styleUrls: ['./icon-cell-renderer.component.scss'],
})
export class IconCellRendererComponent extends CellRendererBase {
  dataToRender = '';
  icons: IconCellIcon[];
  reverseOrder = false;
  showTextTooltip = true;

  constructor(
    @Inject(CELL_RENDERER_TOKEN)
    @Optional()
    params: CellRendererData<object | boolean | string | number>,
    protected _eventTransportService: MessageTransportService,
    private xsI18nPipe: XsI18nPipe,
    private _lsImagePipe: LsImagePipe
  ) {
    super(params, _eventTransportService);
  }

  static getDataToRender(data, xsI18nPipe: XsI18nPipe): string {
    // If the data passed through a mapper, it has a value, else it's raw data.
    if (data === undefined || data === null) {
      return xsI18nPipe.transform('constant_no_data_label');
    }
    const value = data.hasOwnProperty('value') ? data.value : data;
    return value && value !== '' ? <string>value : xsI18nPipe.transform('constant_no_data_label');
  }

  static getIconsToRender(params, data): IconCellIcon[] {
    // TODO - We might have to force the default 'insight-icon-device' if no explicit icon is specified
    if (params?.icons?.length > 0) {
      return params.icons;
    }
    if (data?.icons?.length > 0) {
      return data.icons;
    }
    return [];
  }

  static getImgPathByName(icons: IconCellIcon[], imagePipe: LsImagePipe): IconCellIcon[] {
    return icons.map(icon => (icon.iconName ? { ...icon, img: <string>imagePipe.transform(icon.iconName) } : icon));
  }

  init(cellData: CellRendererData<IconCellData>) {
    this.icons = IconCellRendererComponent.getIconsToRender(cellData.params, cellData.data);
    this.reverseOrder = cellData.data?.reverseOrder;
    this.showTextTooltip = cellData.data?.showTextTooltip !== false;
    this.icons = IconCellRendererComponent.getImgPathByName(this.icons, this._lsImagePipe);
    this.dataToRender = IconCellRendererComponent.getDataToRender(cellData.data, this.xsI18nPipe);
  }
}
